import { render, staticRenderFns } from "./ProposalProductSlider.vue?vue&type=template&id=46b882ae"
import script from "./ProposalProductSlider.vue?vue&type=script&lang=js"
export * from "./ProposalProductSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports